<style lang="less" scoped>
/deep/.el-tabs__nav>.el-tabs__item{padding: 0px !important;}
/deep/.el-tabs__item {width: 120px;font-size: 14px;padding: 0px;}
</style>

<template>
  <div>
    <el-tabs v-model="editableTabsValue" type="card" v-if='this.userData.groupid !== "8"'>
      <el-tab-pane label='我的咨询' name='1'>
        <ConsultingMy :userdata='userdata'></ConsultingMy>
      </el-tab-pane>
      <el-tab-pane label='其他咨询' name='2'>
        <ConsultingOther :userdata='userdata'></ConsultingOther>
      </el-tab-pane>
    </el-tabs>
    <el-tabs v-model="editableTabsValue" type="card" v-if='this.userData.groupid === "8"'>
      <el-tab-pane label='咨询内容列表' name='1'>
        <ConsultingList :userdata='userdata'></ConsultingList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/**
 * 安进
 * 会员中心--咨询管理页面
 */
import ConsultingMy from './ConsultingMy.vue'
import ConsultingOther from './ConsultingOther.vue'
import ConsultingList from './ConsultingList.vue'
import {mapState} from 'vuex'
export default {
  props: ['userData'],
  components: {
    ConsultingMy,
    ConsultingOther,
    ConsultingList
  },
  data()
  {
    return {
      editableTabsValue: '1',
      userdata: this.userData
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        this.editableTabsValue = nval
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/zxxx/ZX/Zxgl.vue